<script type="text/javascript">

	import "./Form.scss";
	import FormSnackbar from "./FormSnackbar.svelte";
	import UIHelper from "../../Helpers/UIHelper";

	export let id = "form";
	export let snackbar;

	export function setReadOnly (v) {
		let form = document.querySelector("#"+id);
		if (!form) {
			// not initted/mounted yet.
			return;
		}
		//console.log("form", form);
		let all = form.querySelectorAll("input, textarea, select, button");
		//console.log("all", all);

		for(let i = 0; i < all.length; i++) {
			let element = all[i];
			UIHelper.setReadOnly(element, v);
		}
	}
</script>
<svelte:options accessors/>
<div id={id} class='cms-form'>
	<FormSnackbar bind:this={snackbar}/>
	<slot/>
</div>
